import {
  createContext,
  type FunctionComponent,
  type PropsWithChildren,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react';
import AnalyticsClient from '../../clients/analytics-client';

export const AnalyticsContext = createContext<AnalyticsClient | null>(null);

export const useAnalytics = () => {
  const client = useContext(AnalyticsContext);
  if (!client) {
    throw new Error('useAnalytics can only be used under an AnalyticsProvider');
  }
  return client;
};

const AnalyticsProvider: FunctionComponent<
  PropsWithChildren<{ loading: ReactNode }>
> = ({ children, loading }) => {
  const [client, setClient] = useState<AnalyticsClient | null>(null);

  useEffect(() => {
    const client = new AnalyticsClient();
    setClient(client);
  }, []);

  return client ? (
    <AnalyticsContext.Provider value={client}>
      {children}
    </AnalyticsContext.Provider>
  ) : (
    loading
  );
};

export default AnalyticsProvider;
